import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useRealTimeSubscription } from '@core/providers/useRealTimeSubscription'
import { PusherOptions } from '@core/providers/usePusher'
import { checklistKeys } from '@core/react-query/features/checklists/checklist'
import { checklistsKeys } from '@core/react-query/features/checklists'

export const useRealTimeChecklist = (
  checklistId: number,
  options?: PusherOptions,
) => {
  const { channel, bindEventHandler } = useRealTimeSubscription(
    `private-checklist.${checklistId}`,
    options,
  )
  const queryClient = useQueryClient()

  useEffect(() => {
    bindEventHandler('checklist.updated', () => {
      const queryKey = checklistKeys.byId({ checklistId }).queryKey
      queryClient.invalidateQueries(queryKey)

      // Invalidate checklist list queries so the list view reflects the updated status (This filters out the mine checklists as well)
      queryClient.invalidateQueries({
        queryKey: checklistsKeys.allChecklists._def,
      })
    })
  }, [channel])
}
